import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import validator from '../../helpers/validator'
import { setAttribute } from '../../actions/registration'

import tellUsMoreImage from '../../assets/images/tell-us-more.png'

class HomeRegistration extends Component {
  constructor(props) {
    super(props)

    this.onCityChange = this.onCityChange.bind(this)
    this.onCityKeyDown = this.onCityKeyDown.bind(this)
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onEmailKeyDown = this.onEmailKeyDown.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onGenderChange = this.onGenderChange.bind(this)

    this.state = {
      error: '',
      city: '',
      email: '',
      name: '',
      gender: '',
      submitting: false,
    }
  }

  componentDidMount() {
    if (!this.props.startOk) {
      this.props.history.push('/')
    }
  }

  onEmailChange(event) {
    this.props.setAttribute('email', event.currentTarget.value)
    this.setState({
      email: event.currentTarget.value,
    })
  }

  onCityChange(event) {
    this.props.setAttribute('city', event.currentTarget.value)
    this.setState({
      city: event.currentTarget.value,
    })
  }

  onGenderChange(event) {
    this.props.setAttribute('gender', event.currentTarget.value)
    this.setState({
      gender: event.currentTarget.value,
    })
  }

  onEmailKeyDown(event) {
    if (event.keyCode === 13) {
      if (this.state.email.length > 0) {
        this.cityInput.focus()

        event.preventDefault()
      }
    }
  }

  onCityKeyDown(event) {
    if (event.keyCode === 13) {
      if (this.state.city.length > 0) {
        this.genderFemaleInput.focus()

        event.preventDefault()
      }
    }
  }

  onFormSubmit(event) {
    event.preventDefault()

    if (!validator.validateFormatEmail.isValueValid(this.state.email)) {
      this.setState({
        error: 'Por favor, informe um endereço de e-mail válido',
      })
      this.modal.show()
      return
    }

    if (!validator.validateRequired.isValueValid(this.state.city)) {
      this.setState({
        error: 'Por favor, informe sua cidade',
      })
      this.modal.show()
      return
    }

    if (!validator.validateIn.isValueValid(this.state.gender, ['female', 'male'])) {
      this.setState({
        error: 'Por favor, informe o sexo',
      })
      this.modal.show()
      return
    }

    this.setState({
      submitting: true,
    })

    this.props.setAttribute('registration-ok', true)

    this.persistData()
  }

  persistData() {
    const currentTime = new Date()
    const registration = ['birthday', 'city', 'email', 'gender', 'name'].reduce(
      (result, key) => ({
        ...result,
        [key]: this.props.registration[key],
      }), {
        timestamp: currentTime,
        unix_time: currentTime.getTime(),
      },
    )

    global.firebase.firestore().collection('registrations')
      .add(registration)
      .then((document) => {
        this.props.setAttribute('id', document.id)

        this.props.history.push('/result')
      })
  }

  renderSubmitButton() {
    if (this.state.submitting) {
      return (
        <button
          className="btn btn-primary"
          disabled
          type="submit"
        >
          <i className="fa fa-refresh fa-spin" />
          &nbsp;
          Continuar
        </button>
      )
    }

    return (
      <button
        className="btn btn-primary"
        type="submit"
      >
        Continuar
      </button>
    )
  }

  render() {
    return (
      <div className="background continua-cadastro">
        <div className="home-primeira-tela">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="title">
                  <img
                    src={tellUsMoreImage}
                    alt="Descubra seu futuro"
                    title="Descubra seu futuro"
                  />
                </div>
              </div>

              <div className="col-md-2" />

              <div className="col-md-8">
                <div className="formulario-um">
                  <form className="form-inline" onSubmit={this.onFormSubmit}>
                    <div className="form-group">
                      <label className="sr-only" htmlFor="email">seu e-mail</label>
                      <input
                        className="camposformulario form-control"
                        id="email"
                        onChange={this.onEmailChange}
                        onKeyDown={this.onEmailKeyDown}
                        placeholder="seu e-mail"
                        type="email"
                      />
                    </div>

                    <div className="form-group">
                      <label className="sr-only" htmlFor="city">sua cidade</label>
                      <input
                        ref={(ref) => { this.cityInput = ref }}
                        className="camposformulario form-control"
                        id="city"
                        onChange={this.onCityChange}
                        onKeyDown={this.onCityKeyDown}
                        placeholder="sua cidade"
                        type="text"
                      />
                    </div>

                    <div className="campos-sexo">
                      <p className="titlecampo">SEXO</p>

                      <label className="custom-control custom-radio" htmlFor="gender-female">
                        <input
                          ref={(ref) => { this.genderFemaleInput = ref }}
                          className="custom-control-input"
                          id="gender-female"
                          onChange={this.onGenderChange}
                          name="gender"
                          type="radio"
                          value="female"
                        />
                        <span className="custom-control-indicator">F</span>
                      </label>

                      <label className="custom-control custom-radio" htmlFor="gender-male">
                        <input
                          ref={(ref) => { this.genderMaleInput = ref }}
                          className="custom-control-input"
                          id="gender-male"
                          onChange={this.onGenderChange}
                          name="gender"
                          type="radio"
                          value="male"
                        />
                        <span className="custom-control-indicator">M</span>
                      </label>
                    </div>

                    <div className="clear" />

                    <div className="form-group-bt-continuar">
                      {this.renderSubmitButton()}
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-md-2" />
            </div>
          </div>
        </div>

        <ErrorModal
          ref={(ref) => { this.modal = ref }}
          message={this.state.error}
        />
      </div>
    )
  }
}

HomeRegistration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    birthday: PropTypes.string,
    city: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  setAttribute: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeRegistration.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeRegistration)



// WEBPACK FOOTER //
// ./src/components/home/Registration.js